import { Helmet } from "react-helmet-async";
import { PRODUCTION_URL } from "@/lib/config";

interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogImage?: string;
  ogType?: "website" | "article" | "product";
  noIndex?: boolean;
}

const SEOHead = ({
  title,
  description,
  keywords,
  canonicalUrl,
  ogImage = "/og-image.png",
  ogType = "website",
  noIndex = false,
}: SEOHeadProps) => {
  const BRAND = "Lombrici";
  const fullTitle = title.includes(BRAND) ? title : `${title} | ${BRAND}`;

  // Build absolute URLs for SEO
  const absoluteCanonicalUrl = canonicalUrl?.startsWith('http') 
    ? canonicalUrl 
    : canonicalUrl 
      ? `${PRODUCTION_URL}${canonicalUrl}` 
      : undefined;
  
  const absoluteOgImage = ogImage?.startsWith('http') 
    ? ogImage 
    : `${PRODUCTION_URL}${ogImage}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      {absoluteCanonicalUrl && <link rel="canonical" href={absoluteCanonicalUrl} />}
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={absoluteOgImage} />
      {absoluteCanonicalUrl && <meta property="og:url" content={absoluteCanonicalUrl} />}
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={absoluteOgImage} />
    </Helmet>
  );
};

export default SEOHead;
